import React from 'react';

import Tabs from '@material-ui/core/Tabs';

import { Container } from './styles';

type TabBarProps = {
  selectedTab: number;
  onChange?: (event: React.ChangeEvent<{}>, value: any) => void;
};

const TabBar: React.FC<TabBarProps> = ({ selectedTab, children, ...rest }) => {
  return (
    <Container>
      <Tabs
        value={selectedTab}
        variant="scrollable"
        scrollButtons="auto"
        {...rest}
      >
        {children}
      </Tabs>
    </Container>
  );
};

export default TabBar;
